import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-primary-600">无尽漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注漫画追更情报，实时整理今日更新与最新话，按连载状态筛选即可查询更新到第几话、掌握追更进度。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">快捷入口</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><Link to="/list?status=连载中" className="hover:text-primary-600">连载中漫画</Link></li>
              <li><Link to="/list?status=已完结" className="hover:text-primary-600">已完结漫画</Link></li>
              <li><Link to="/list" className="hover:text-primary-600">全部分类</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">分类浏览</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li><Link to="/list?category=热血冒险" className="hover:text-primary-600">热血冒险</Link></li>
              <li><Link to="/list?category=奇幻异世界" className="hover:text-primary-600">奇幻异世界</Link></li>
              <li><Link to="/list?category=恋爱校园" className="hover:text-primary-600">恋爱校园</Link></li>
              <li><Link to="/list?category=古风武侠" className="hover:text-primary-600">古风武侠</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">关于本站</h3>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/faq" className="hover:text-primary-600">常见问题</Link></li>
              <li><a href="mailto:support@wujinmanhua.com" className="hover:text-primary-600">support@wujinmanhua.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 无尽漫画网 · 追更进度与连载状态查询</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-500"></i>
            愿你所追的每一部，都有光明的下一话
          </p>
        </div>
      </div>
    </footer>
  );
}